import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixGraficaAvanceFisico from '@/components/administracion/ejecucion/graficaavancefisico/mixGraficaAvanceFisico';

export default {
  name: 'MainGraficaAvanceFisico',
  data() {
    return {
      activarMostrarGrafica: false,
    };
  },
  mixins: [mixGenerarPdf, mixGraficaAvanceFisico],
  methods: {

    mostrarGrafica() {
      this.activarMostrarGrafica = true;
      this.$emit('mostrarGrafica');
    },

    async generarPdfGraficaAvanceFisico() {
      this.generandoPdfGraficaAvanceFisico = true;
      const nombreTemplate = 'templateGraficaAvanceFisico';
      const grafica = this.mixPuntosGrafica;
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const avanceProgramado = grafica
        ?.programadoPorcentaje[grafica.financieroPorcentaje.length - 1];
      const avanceFinanciero = grafica
        ?.financieroPorcentaje[grafica.financieroPorcentaje.length - 1];
      const avanceFisico = grafica?.fisicoPorcentaje[grafica.fisicoPorcentaje.length - 1];

      const cliente = this.getCliente || { logo: '', nombre: '' };

      const graficaConFormato = {
        programado: grafica.programado.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        financiero: grafica.financiero.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        fisico: grafica.fisico.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        programadoP: grafica.programadoPorcentaje.map((p) => `${p}%`),
        financieroP: grafica.financieroPorcentaje.map((p) => `${p}%`),
        fisicoP: grafica.fisicoPorcentaje.map((p) => `${p}%`),
        numeroMeses: grafica.programado.length,
      };

      const ultimaEstimacion = this.formatoObjeto(this.getUltimaEstimacion) || {};
      const tipo = this.getTipoSubtipo;

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          grafica,
          graficaConFormato,
          contrato: contratoConFormato,
          avanceProgramado,
          avanceFinanciero,
          avanceFisico,
          cliente,
          estimacion: ultimaEstimacion,
          tipo,
          footer: '',
        },
      }, `${this.getContrato.numero}_GraficaAvanceProg_Fin_Fis`);
      this.generandoPdfGraficaAvanceFisico = false;
    },

  },
  computed: {

  },
};
